

import { MyPublicProfileModel } from "@dana/Services/DanaMyPublicProfileService";
import MyPublicProfileState from "@dana/Store/Data/MyPublicProfile/MyPublicProfileState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialCounterState: MyPublicProfileState = {
    myPublicProfile: {} as any,
    isLoading: false,
};

const myPublicProfileStateImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "MyPublicProfile/BeginLoad": (draft: Draft<MyPublicProfileState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "MyPublicProfile/CompleteLoadProfile": (draft: Draft<MyPublicProfileState>, action: { myPublicProfile: MyPublicProfileModel }) => {
         draft.myPublicProfile = action.myPublicProfile;
    },
    "MyPublicProfile/EndLoad": (draft: Draft<MyPublicProfileState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
});


(reducers as any).myPublicProfileState = myPublicProfileStateImmerReducer;

type MyPublicProfileReducers = {
    myPublicProfileState: typeof myPublicProfileStateImmerReducer;
};

export type MyPublicProfileActions = Parameters<MyPublicProfileReducers[keyof MyPublicProfileReducers]>[1] | AnyAction;


